<template>
  <div class="tz-tool">
    <!-- 世界时钟 -->
    <div class="tz-section">
      <div class="tz-section-title"><span class="tz-dot" /> {{ $t('tool.TimezoneConverter.worldClock') }}</div>
      <div class="tz-clocks">
        <div v-for="tz in quickZones" :key="tz.value" class="tz-clock" :class="{ 'tz-clock-local': tz.value === localTz }">
          <div class="tz-clock-name">{{ tz.label }}</div>
          <div class="tz-clock-time">{{ fmtClock(tz.value) }}</div>
          <div class="tz-clock-date">{{ fmtDate(tz.value) }}</div>
          <div class="tz-clock-offset">{{ fmtOffset(tz.value) }}</div>
        </div>
      </div>
    </div>

    <!-- 时区转换 -->
    <div class="tz-section">
      <div class="tz-section-title"><span class="tz-dot" /> {{ $t('tool.TimezoneConverter.converter') }}</div>
      <div class="tz-convert">
        <div class="tz-cv-field">
          <label>{{ $t('tool.TimezoneConverter.fromTz') }}</label>
          <el-select v-model="srcTz" size="small" filterable style="width:100%">
            <el-option v-for="z in allZones" :key="z.value" :label="z.label" :value="z.value" />
          </el-select>
        </div>
        <div class="tz-cv-field">
          <label>{{ $t('tool.TimezoneConverter.dateTimeLabel') }}</label>
          <el-date-picker v-model="srcTime" type="datetime" size="small" :placeholder="$t('tool.TimezoneConverter.dateTimePlaceholder')" style="width:100%" @change="convert" />
        </div>
        <div class="tz-cv-field">
          <label>{{ $t('tool.TimezoneConverter.toTz') }}</label>
          <el-select v-model="dstTz" size="small" filterable style="width:100%" @change="convert">
            <el-option v-for="z in allZones" :key="z.value" :label="z.label" :value="z.value" />
          </el-select>
        </div>
        <div class="tz-cv-field tz-cv-btn">
          <label>&nbsp;</label>
          <el-button size="small" @click="now">{{ $t('tool.TimezoneConverter.btnNow') }}</el-button>
        </div>
      </div>
      <div class="tz-result" v-if="result">
        <span class="tz-result-src">{{ fmtFull(srcTz, srcTime) }}</span>
        <i class="el-icon-right tz-arrow" />
        <span class="tz-result-dst">{{ fmtFull(dstTz, result) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
var ZONES = [
  { label:'UTC', value:'UTC' },
  // 亚洲 (10)
  { label:'亚洲/上海 (CST +8)', value:'Asia/Shanghai' },
  { label:'亚洲/东京 (JST +9)', value:'Asia/Tokyo' },
  { label:'亚洲/首尔 (KST +9)', value:'Asia/Seoul' },
  { label:'亚洲/新加坡 (SGT +8)', value:'Asia/Singapore' },
  { label:'亚洲/香港 (HKT +8)', value:'Asia/Hong_Kong' },
  { label:'亚洲/台北 (CST +8)', value:'Asia/Taipei' },
  { label:'亚洲/曼谷 (+7)', value:'Asia/Bangkok' },
  { label:'亚洲/雅加达 (WIB +7)', value:'Asia/Jakarta' },
  { label:'亚洲/迪拜 (+4)', value:'Asia/Dubai' },
  { label:'亚洲/加尔各答 (IST +5:30)', value:'Asia/Kolkata' },
  { label:'亚洲/卡拉奇 (PKT +5)', value:'Asia/Karachi' },
  { label:'亚洲/德黑兰 (+3:30)', value:'Asia/Tehran' },
  // 欧洲 (6)
  { label:'欧洲/伦敦 (BST/GMT)', value:'Europe/London' },
  { label:'欧洲/巴黎 (CET/CEST)', value:'Europe/Paris' },
  { label:'欧洲/柏林 (CET/CEST)', value:'Europe/Berlin' },
  { label:'欧洲/莫斯科 (MSK +3)', value:'Europe/Moscow' },
  { label:'欧洲/伊斯坦布尔 (+3)', value:'Europe/Istanbul' },
  { label:'欧洲/马德里 (CET/CEST)', value:'Europe/Madrid' },
  // 美洲 (8)
  { label:'美洲/纽约 (EST/EDT)', value:'America/New_York' },
  { label:'美洲/多伦多 (EST/EDT)', value:'America/Toronto' },
  { label:'美洲/芝加哥 (CST/CDT)', value:'America/Chicago' },
  { label:'美洲/丹佛 (MST/MDT)', value:'America/Denver' },
  { label:'美洲/洛杉矶 (PST/PDT)', value:'America/Los_Angeles' },
  { label:'美洲/墨西哥城 (CST)', value:'America/Mexico_City' },
  { label:'美洲/圣保罗 (-3)', value:'America/Sao_Paulo' },
  { label:'美洲/布宜诺斯艾利斯 (-3)', value:'America/Argentina/Buenos_Aires' },
  // 非洲 (2)
  { label:'非洲/开罗 (EET +2)', value:'Africa/Cairo' },
  { label:'非洲/约翰内斯堡 (SAST +2)', value:'Africa/Johannesburg' },
  // 大洋洲 (3)
  { label:'澳洲/悉尼 (AEST/AEDT)', value:'Australia/Sydney' },
  { label:'澳洲/珀斯 (AWST +8)', value:'Australia/Perth' },
  { label:'太平洋/奥克兰 (NZST/NZDT)', value:'Pacific/Auckland' },
  { label:'太平洋/火奴鲁鲁 (HST -10)', value:'Pacific/Honolulu' }
]

var QUICK = [
  { label:'北京', value:'Asia/Shanghai' },
  { label:'东京', value:'Asia/Tokyo' },
  { label:'新加坡', value:'Asia/Singapore' },
  { label:'迪拜', value:'Asia/Dubai' },
  { label:'伦敦', value:'Europe/London' },
  { label:'巴黎', value:'Europe/Paris' },
  { label:'莫斯科', value:'Europe/Moscow' },
  { label:'纽约', value:'America/New_York' },
  { label:'洛杉矶', value:'America/Los_Angeles' },
  { label:'悉尼', value:'Australia/Sydney' }
]

export default {
  name:'TimezoneConverter',
  data() {
    var now = new Date()
    return {
      quickZones: QUICK,
      allZones: ZONES,
      localTz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      srcTz: 'Asia/Shanghai',
      dstTz: 'America/New_York',
      srcTime: now,
      result: this.convertTz(now, 'Asia/Shanghai', 'America/New_York'),
      clockTick: 0
    }
  },
  created() {
    this._timer = setInterval(() => { this.clockTick++ }, 10000)
    this.convert()
  },
  beforeDestroy() { clearInterval(this._timer) },
  methods: {
    fmt(tz, date, opts) {
      try {
        return new Intl.DateTimeFormat('zh-CN', { timeZone: tz, ...opts }).format(date)
      } catch(e) { return '--' }
    },
    fmtClock(tz) {
      this.clockTick // reactive dependency
      return this.fmt(tz, new Date(), { hour:'2-digit', minute:'2-digit', second:'2-digit' })
    },
    fmtDate(tz) {
      return this.fmt(tz, new Date(), { year:'numeric', month:'2-digit', day:'2-digit', weekday:'short' })
    },
    fmtOffset(tz) {
      try {
        var d = new Date()
        var utc = new Intl.DateTimeFormat('en', { timeZone:'UTC', hour:'numeric', minute:'numeric', hour12:false }).format(d)
        var local = new Intl.DateTimeFormat('en', { timeZone: tz, hour:'numeric', minute:'numeric', hour12:false }).format(d)
        var u = utc.split(':'), l = local.split(':')
        var off = (parseInt(l[0]) - parseInt(u[0])) * 60 + (parseInt(l[1]) - parseInt(u[1]))
        var sign = off >= 0 ? '+' : '-'
        var h = Math.floor(Math.abs(off) / 60)
        var m = Math.abs(off) % 60
        return 'UTC' + sign + h + (m ? ':' + String(m).padStart(2,'0') : '')
      } catch(e) { return '' }
    },
    fmtFull(tz, date) {
      return this.fmt(tz, date, { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false })
    },
    convertTz(date, fromTz, toTz) {
      try {
        var str = new Intl.DateTimeFormat('en', { timeZone: fromTz, year:'numeric', month:'2-digit', day:'2-digit',
          hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false }).format(date)
        var parts = str.match(/(\d+)\/(\d+)\/(\d+),\s(\d+):(\d+):(\d+)/)
        if (!parts) return new Date(date.getTime())
        var iso = parts[1] + '-' + parts[2] + '-' + parts[3] + 'T' + parts[4] + ':' + parts[5] + ':' + parts[6]
        var localDate = new Date(iso + 'Z')
        var toStr = new Intl.DateTimeFormat('en', { timeZone: toTz, year:'numeric', month:'2-digit', day:'2-digit',
          hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false }).format(localDate)
        var toParts = toStr.match(/(\d+)\/(\d+)\/(\d+),\s(\d+):(\d+):(\d+)/)
        if (!toParts) return localDate
        return new Date(toParts[1] + '-' + toParts[2] + '-' + toParts[3] + 'T' + toParts[4] + ':' + toParts[5] + ':' + toParts[6])
      } catch(e) { return new Date(date.getTime()) }
    },
    convert() {
      if (!this.srcTime) return
      this.result = this.convertTz(this.srcTime, this.srcTz, this.dstTz)
    },
    now() {
      this.srcTime = new Date()
      this.convert()
    }
  }
}
</script>

<style scoped>
.tz-tool { display: flex; flex-direction: column; gap: 24px; }

.tz-section-title { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 700; color: #1a1f36; margin-bottom: 12px; }
.tz-dot { width: 8px; height: 8px; border-radius: 50%; background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,.4); }

/* 世界时钟 */
.tz-clocks { display: grid; grid-template-columns: repeat(auto-fill, minmax(170px, 1fr)); gap: 12px; }
.tz-clock {
  background: #fafbfc; border: 1px solid #ebeef5; border-radius: 10px;
  padding: 14px 16px; text-align: center; transition: all .15s;
}
.tz-clock:hover { border-color: #4e7cff; }
.tz-clock-local { border-color: #4e7cff; background: #f0f4ff; }
.tz-clock-name { font-size: 13px; color: #606266; margin-bottom: 6px; }
.tz-clock-time { font-size: 22px; font-weight: 700; color: #1a1f36; font-family: 'Courier New', monospace; letter-spacing: 1px; }
.tz-clock-date { font-size: 11px; color: #909399; margin-top: 4px; }
.tz-clock-offset { font-size: 11px; color: #c0c4cc; margin-top: 2px; }

/* 时区转换 */
.tz-convert { display: grid; grid-template-columns: 2fr 2fr 2fr 1fr; gap: 12px; align-items: end; }
.tz-cv-field { display: flex; flex-direction: column; gap: 4px; }
.tz-cv-field label { font-size: 12px; font-weight: 600; color: #909399; }

.tz-result {
  display: flex; align-items: center; justify-content: center; gap: 16px;
  margin-top: 16px; padding: 16px 24px; background: #f0f9eb; border: 1px solid #e1f3d8;
  border-radius: 10px; font-size: 13px;
}
.tz-result-src { color: #909399; word-break: break-all; }
.tz-arrow { color: #67c23a; font-size: 18px; flex-shrink: 0; }
.tz-result-dst { color: #303133; font-weight: 700; word-break: break-all; }

@media (max-width: 768px) {
  .tz-convert { grid-template-columns: 1fr 1fr; }
  .tz-clocks { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); }
}
</style>
